import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/productWarning.svg';

export const IconProductWarning = createIconComponent(Icon);
